export const POST_VISIBILITIES = {
  EVERYONE: 'everyone',
  FOLLOWERS: 'followers',
  PRIVATE: 'private',
  NEARBY: 'nearby'
};

export const VALID_VISIBILITIES = Object.values(POST_VISIBILITIES); 